import { Truck, ShieldCheck, RotateCcw, Headphones } from 'lucide-react';

const FEATURES = [
  { Icon: Truck,       color: 'primary',   title: 'Free Shipping', desc: 'On all orders over $50' },
  { Icon: ShieldCheck, color: 'accent3',   title: 'Safe & Tested', desc: 'All products are certified' },
  { Icon: RotateCcw,   color: 'secondary', title: 'Easy Returns',  desc: '30-day return policy' },
  { Icon: Headphones,  color: 'accent1',   title: '24/7 Support',  desc: "We're here to help" },
];

const STYLES = {
  primary:   { bg: 'from-primary/20 to-primary/10',     text: 'text-primary',   border: 'border-primary/10'   },
  accent3:   { bg: 'from-accent3/20 to-accent3/10',     text: 'text-accent3',   border: 'border-accent3/10'   },
  secondary: { bg: 'from-secondary/20 to-secondary/10', text: 'text-secondary', border: 'border-secondary/10' },
  accent1:   { bg: 'from-accent1/20 to-accent1/10',     text: 'text-accent1',   border: 'border-accent1/10'   },
};

export default function WhyChooseSection({
  title    = 'Why Choose KiddieJoy?',
  subtitle = 'We make shopping for kids fun and easy!',
}) {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-accent2/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-textDark mb-4">{title}</h2>
          {subtitle && <p className="text-xl text-textLight">{subtitle}</p>}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {FEATURES.map(({ Icon, color, title: t, desc }) => {
            const s = STYLES[color];
            return (
              <div key={t} className={`bg-white rounded-3xl p-8 text-center shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 border-4 ${s.border}`}>
                <div className={`w-20 h-20 bg-gradient-to-br ${s.bg} rounded-2xl flex items-center justify-center mx-auto mb-6`}>
                  <Icon className={`w-9 h-9 ${s.text}`} />
                </div>
                <h3 className="font-black text-xl text-textDark mb-3">{t}</h3>
                <p className="text-textLight">{desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
